import React, { useContext, useEffect, useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import { BiMessageSquareEdit, BiTrash } from "react-icons/bi";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { Skeleton } from "../../components/Skeleton/table";
import MyTooltip from "../../components/Tooltip";
import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import {
	Apresentation,
	ContentMain,
	DefaultButton,
	Error,
	MyTable,
	MyTableBody,
	MyTableHead,
	MyTableTR,
	Page,
	ScreenView,
	SubPageMain,
} from "../../style/default";
import { CreateUpdateModal } from "./createUpdateModal";
import { EditUpdateModal } from "./editUpdateModal";
import { SeeUpdateModal } from "./seeUpdateModal";
import { DeleteUpdateModal } from "./deleteUpdateModal";

const Updates = () => {
	const { open, handleOpenModal } = useContext(ModalContext);

	const [isLoading, setIsLoading] = useState(false);
	const [tableData, setTableData] = useState([]);

	const [selectedUpdate, setSelectedUpdate] = useState({});

	const [modais, setModais] = useState({
		see: false,
		create: false,
		edit: false,
		delete: false,
	});

	const closeAllModais = (modalName) => {
		const objFalse = Object.entries(modais).map(([key]) => ({
			[key]: false,
		}));
		setModais({ ...objFalse, [modalName]: true });
	};

	const handleModais = (modalName, item) => {
		closeAllModais(modalName);
		setSelectedUpdate(item);
		handleOpenModal();
	};

	const handleUpdates = async () => {
		try {
			setIsLoading(true);
			const { data } = await authApi.get("/updates");
			setTableData(data);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		handleUpdates();
	}, []);

	return (
		<Page>
			{open && modais.create ? (
				<CreateUpdateModal open={open} handleUpdates={handleUpdates} />
			) : null}
			{open && modais.edit ? (
				<EditUpdateModal
					data={selectedUpdate}
					open={open}
					handleUpdates={handleUpdates}
				/>
			) : null}
			{open && modais.see ? (
				<SeeUpdateModal data={selectedUpdate} open={open} />
			) : null}
			{open && modais.delete ? (
				<DeleteUpdateModal
					data={selectedUpdate}
					open={open}
					handleUpdates={handleUpdates}
				/>
			) : null}
			<Sidebar activeMenu="updates" />
			<ScreenView>
				<ContentMain>
					<SubPageMain>
						<Apresentation>
							<span>Atualizações da plataforma</span>
							<DefaultButton
								headerButton
								onClick={() => {
									handleModais("create");
								}}
							>
								Cadastrar nova atualização
							</DefaultButton>
						</Apresentation>
						{isLoading ? (
							<Skeleton data={["data", "título", "conteúdo", "ações"]} />
						) : (
							<>
								{tableData.length ? (
									<>
										<MyTable responsive>
											<MyTableHead>
												<MyTableTR>
													<th>data</th>
													<th>título</th>
													<th>contúdo</th>
													<th>status</th>
													<th>ações</th>
												</MyTableTR>
											</MyTableHead>
											<MyTableBody>
												{tableData.map((item) => (
													<MyTableTR key={item._id}>
														<td>{item.updateDate}</td>
														<td>{item.title}</td>
														<td>Clique em "visualizar todo o conteúdo"</td>
														<td>{item?.active ? "ativo" : "inativo"}</td>
														<td
															style={{
																display: "flex",
																justifyContent: "center",
															}}
														>
															<MyTooltip label="Visualizar todo conteúdo">
																<DefaultButton
																	onClick={() => {
																		handleModais("see", item);
																	}}
																>
																	<AiOutlineEye size={20} />
																</DefaultButton>
															</MyTooltip>
															<MyTooltip label="Editar atualização">
																<DefaultButton
																	onClick={() => {
																		handleModais("edit", item);
																	}}
																>
																	<BiMessageSquareEdit size={20} />
																</DefaultButton>
															</MyTooltip>
															<MyTooltip label="Deletar atualização">
																<DefaultButton
																	onClick={() => {
																		handleModais("delete", item);
																	}}
																>
																	<BiTrash size={20} />
																</DefaultButton>
															</MyTooltip>
														</td>
													</MyTableTR>
												))}
											</MyTableBody>
										</MyTable>
									</>
								) : (
									<Error>Nenhum dado encontrado</Error>
								)}
							</>
						)}
					</SubPageMain>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
};

export { Updates };
